import React from 'react';
import ContentLoader from "react-content-loader";
import { USER_DASHBOARD_BULLION } from '../../../../constants';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { updateCompanyDashboardAction } from '../../../../actions/companyDashboard';

export default function CompanyAccountDetails({ isEditing, setIsEditing }) {
    const dispatch = useDispatch()
    const { isAdminLoggedIn } = useSelector((state) => state.auth);
    const { companyDashboard, isCompanyDashboardLoading } = useSelector((state) => state.companyDashboard);
    const { selectedCompany } = useSelector((state) => state.company);

    const {
        register,
        handleSubmit,
    } = useForm();

    const onSubmit = (data) => {
        if (selectedCompany?.id) {
            dispatch(updateCompanyDashboardAction(selectedCompany?.id, data))
        }
        setIsEditing(null);
    };

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='accountBorderSection'>
                    <div className='container-fluid p-0'>
                        <div className="content-row-padding">
                            <div className='row'>
                                <div className='col-4'>
                                    <h6 className='accountPrimaryText'>Company account number</h6>

                                    {isCompanyDashboardLoading ? (
                                        <div>
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    ) : (
                                        <div className='accountSecondaryText'>{selectedCompany?.companyAccountNumber || 'XXXXXXXX-XXXXXX'}</div>
                                    )}
                                </div>

                                <div className='col-4'>
                                    <h6 className='accountPrimaryText'>Issued Share capital</h6>

                                    {isCompanyDashboardLoading ? (
                                        <div>
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    ) : (
                                        <div>
                                            {isEditing === USER_DASHBOARD_BULLION.PERSONAL ? (
                                                <input
                                                    type='text'
                                                    className='form-control customInputField textInputAlignText'
                                                    {...register("shareCapital", {})}
                                                    defaultValue={companyDashboard?.shareCapital || ""}
                                                />
                                            ) : (
                                                <div className='accountSecondaryText'>{companyDashboard?.shareCapital || "-"}</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className='col-4 text-right'>
                                    <h6 className='accountPrimaryText'>Paid-up capital</h6>
                                    {isCompanyDashboardLoading ? (
                                        <div>
                                            <ContentLoader width="100%" height={15}>
                                                <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                            </ContentLoader>
                                        </div>
                                    ) : (
                                        <div>
                                            {isEditing === USER_DASHBOARD_BULLION.PERSONAL ? (
                                                <input
                                                    type='text'
                                                    className='form-control customInputField textInputAlignText'
                                                    {...register("paidupCapital", {})}
                                                    defaultValue={companyDashboard?.paidupCapital || ""}
                                                />
                                            ) : (
                                                <div className='accountSecondaryText'>{companyDashboard?.paidupCapital || "-"}</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {isAdminLoggedIn &&
                                    <div className='col-12 text-right'>
                                        {isCompanyDashboardLoading ? (
                                            <div className='row HeadericonAlign'>
                                                <div className='col-12 rightAlignText'>
                                                    <div style={{ width: '100%', marginLeft: 'auto' }}>
                                                        <ContentLoader width="100%" height={15}>
                                                            <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                                        </ContentLoader>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='row mb-2'>
                                                <div className='col-12 rightAlignText'>
                                                    {isEditing === USER_DASHBOARD_BULLION.PERSONAL ? (
                                                        <button className="btn save-button customFilterButton" type='submit'>
                                                            Save
                                                        </button>
                                                    ) : (
                                                        <span className="btn btn-link  px-3 mb-0 edit-button" onClick={() => setIsEditing(USER_DASHBOARD_BULLION.PERSONAL)}>
                                                            <i className="fas fa-pencil-alt edit-button me-2"></i>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
